export enum EActionType {
  ADD = 'add',
  MINUS = 'minus',
  CREATE = 'create',
  NEW = 'new',
  UPLOAD = 'upload',
}

export enum EIconType {
  ADD = 'add',
  MINUS = 'minus',
  LIST = 'list',
}
